import React, {useState} from "react";
import t, {changeLanguage} from "../../../components/I18N/TranslateHelpers";
import {useSelector} from "react-redux";
import {
  GetCurrentLocale, pathname
} from "../../../components/Utils";
import {RootState} from "../../../app/RootReducer";
import {allStepForStepsForm} from "../../../components/UtilsForCart";
import MultiStepsForm from "./MultiStepsForm";

const CreateAccountPage = () => {
  const locale = GetCurrentLocale();
  changeLanguage(locale)

  const isAuthenticated = useSelector((state: RootState) => state.userRdc.isAuthenticated);

  const isCreateAccountPage = pathname === "/" + locale + t("url_create_account");

  const [activeStep, setActiveStep] = useState(0)

  const allSteps = [
    {
      id: "infos",
      label: t("infos"),
      icon: "/images/id-card.png",
      step: 0,
    },
    {
      id: "confirmation",
      label: t("confirmation"),
      icon: "/images/success.png",
      step: 1,
    },
  ];

  if (isAuthenticated && isCreateAccountPage) {
    window.location.href = "/" + locale + t("url_profile");
    return null;
  }

  return (
    <div className="bg-circle-bottom container-create-account py-5">
      <div className="container pb-5 mb-5">
        <div className="card mb-5">
          <div className="card-body">
            <h2 className="text-center py-3">{t("creating_company_account")}</h2>
            <div className="progress-bar" id="topPage">
              {allStepForStepsForm(allSteps, activeStep)}
            </div>
            <div className="form-outer">
              <MultiStepsForm
                isCreateAccount={true}
                isEditForm={false}
                isCartPage={false}
                setActiveStep={setActiveStep}
                activeStep={activeStep}
                remarkText={null}
                setRemarqueText={undefined}
                selectedServices={null}
                setSelectedServices={undefined}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default CreateAccountPage;
